module.exports = __webpack_public_path__ + "img/1.f01e6c5f.png";